import { sendFetch, sendPrinterFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/printer';

export const printStickers = async (body) => {
    return await sendPrinterFetch(`${BASE_PATH}/print`, POST_OPTIONS, body);
}

export const findAllPrinter = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const updatePrinter = async (body) => {
    return await sendFetch(`${BASE_PATH}/update`, POST_OPTIONS, body);
}

export const printStickersRol = async (body) => {
    return await sendPrinterFetch(`${BASE_PATH}/print-rol`, POST_OPTIONS, body);
}

export const printStickersRolNalsani = async (body) => {
    return await sendPrinterFetch(`${BASE_PATH}/print-nalsani-rol`, POST_OPTIONS, body);
}

export const printStickersRolReymon = async (body) => {
    return await sendPrinterFetch(`${BASE_PATH}/print-reymond-rol`, POST_OPTIONS, body);
}

export const printStickersRolEliot = async (body) => {
    return await sendPrinterFetch(`${BASE_PATH}/print-eliot-rol`, POST_OPTIONS, body);
}